import { EnumValue } from '@/components';
import { ArticleStatus } from '@/core/http.articles';
import { ArticleState } from '@/redux/articles';
import { Tag } from 'antd';

interface Props {
  value: Pick<ArticleState, 'status'>;
}

const statusColorMap: Record<ArticleStatus, string> = {
  Draft: 'default',
  Published: 'green',
  Hidden: 'red',
};

export function ArticleStatusBadge({ value }: Props) {
  const { status } = value;

  const color = statusColorMap[status];

  return (
    <Tag color={color}>
      <EnumValue type={ArticleStatus} value={status} />
    </Tag>
  );
}
